import { render } from "./SuccessRequestNewCards.vue?vue&type=template&id=36974ca6&scoped=true"
import script from "./SuccessRequestNewCards.vue?vue&type=script&lang=js"
export * from "./SuccessRequestNewCards.vue?vue&type=script&lang=js"

import "./SuccessRequestNewCards.vue?vue&type=style&index=0&id=36974ca6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36974ca6"]])

export default __exports__